import moment from "moment/moment";
import {isDaumBlogDomain} from "../../../utils/UriUtil";

/**
 * 입력된 날짜를 기준으로 가장 최근의 월요일을 찾아 리턴한다.  // 필요시 뒤에 숫자를 바꿔 찾고싶은 요일을 찾도록 수정 하세요.
 * @param date
 * @param format
 * @returns {string}
 */
export const thisMondayDate = (date, format) => {
  date = moment(date);
  let prevMonday = new Date(date);
  prevMonday.setDate(prevMonday.getDate() - (prevMonday.getDay() + 6) % 7);
  return moment(date).add(date.diff(prevMonday, "days") * -1, 'day').format(format);
};

/**
 *
 * @param date
 * @param format
 * @returns {string}
 */
export const firstDayOfMonth = (date, format) => {
  date = moment(date).format("YYYYMM") + "01";
  return moment(date).format(format);

};

/**
 * 어제
 * @returns {string}
 */
export const yesterday = () => {
  return moment().add(-1, "day").format("YYYY-MM-DD");
};

/**
 * 이전달의 첫번째날
 * @returns {string}
 */
export const firstDayOfPreviousMonth = () => {
  return moment().add(-1, 'months').startOf('month').format("YYYY-MM-DD"); // endOf
};

/**
 * 저번주 월요일
 * @returns {string}
 */
export const mondayOfLastWeek = () => {
  return moment(thisMondayDate(moment(), "YYYY-MM-DD")).add(-1, "week").format("YYYY-MM-DD");
};

/**
 * 오늘날짜
 */
export const now = () => {
  return moment().format("YYYY-MM-DD")
};

/**
 * 날짜의 차이를 계산하여 해당하는 날짜를 포멧팅해서 리턴한다.
 * @param date
 * @param gap
 * @param type
 * @param format
 * @returns {string}
 */
export const diffDate = (date, gap, type, format) => {
  gap = (gap > 0) ? -1 : +1;
  return moment(date).add(gap, type).format(format);
};


/**
 * window 객체에 선언된 점검 정보가 있으면 그값을 사용한다.
 * @returns {boolean}
 */
export const checkAndGetMaintenanceMsg = () => {

  return window.Config.hasOwnProperty('maintenance') && window.Config.maintenance.statistics
    ? window.Config.maintenance.statistics
    : null;
};


/**
 * makeGraphCategoryDate
 * @param list
 * @returns {Array}
 */
export const makeGraphCategoryDate = (list) => {
  let result = [];

  if (list) {
    list.map((item) => {
      let timestamp = item.timestamp;
      result.push({
        year: moment(timestamp).format("YYYY"),
        month: moment(timestamp).format("MM"),
        day: moment(timestamp).format("D"),
        fullDate: moment(timestamp).format("YYYY-MM-DD")
      });
    });
  }

  return result;
};


/**
 * 말줄임 with rTrim
 * @param text
 * @param maxSize
 * @param replaceText
 * @returns {string}
 */
export const ellipsis = (text, maxSize, replaceText) => {

  if (text == "" || text == null || text == undefined) return text;

  if (text.length > maxSize) {
    return text.substring(0, maxSize).replace(/~+$/g, "") + replaceText;
  }

  return text;
};


/**
 * defaultDataProvider
 * @param result
 * @param activeDateType
 * @param standardDate
 * @param gapCount
 * @returns {*}
 */
export const defaultDataProvider = (result, activeDateType, standardDate, gapCount) => {
  if (result.data.length == gapCount) {
    result.data.map((item) => {
      item.fake = 0;
      item.activeDateType = activeDateType;
    });
    return result;
  }

  let tempStandardDate = (standardDate == 'week') ? thisMondayDate(standardDate) : standardDate;
  let defaultResult = Object.assign({}, result, {data: []});

  for (let cursor = 0; cursor < gapCount; cursor++) {
    let existItem = result.data.filter((item) => {
      return (moment(item.timestamp).format("YYYY-MM-DD") == moment(tempStandardDate).add(-cursor, activeDateType).format("YYYY-MM-DD"));
    });

    if (existItem.length > 0) {
      defaultResult.data.push({
        ...existItem[0],
        fake: 0,
        activeDateType: activeDateType
      })
    } else {
      defaultResult.data.push({
        timestamp: moment(tempStandardDate).add(-cursor, activeDateType).format("YYYY-MM-DD") + "T00:00:00.000Z",
        searchEngine: 0,
        etc: 0,
        pv: 0,
        sns: 0,
        fake: 0,
        activeDateType: activeDateType
      });
    }
  }

  defaultResult.data = defaultResult.data.reverse();
  return defaultResult;
};


/**
 * 최초 생성일과 비교하여 이전데이터인지 확인한다.
 * @param type [day, week, month]
 * @param date
 * @param minDate [블로그/게시글 생성일]
 * @returns {*|boolean}
 */
export const checkEarlierThanCreationDate = (type, date, minDate) => {
  switch (type) {
    default:
    case "day":
      return minDate && moment(date).format("YYYY-MM-DD") < moment(minDate).format("YYYY-MM-DD");
    case "week":
      return minDate && moment(date).add(7, "day").format("YYYY-MM-DD") < moment(minDate).format("YYYY-MM-DD");
    case "month":
      return minDate && moment(date).format("YYYY-MM") < moment(minDate).format("YYYY-MM");
    case "year":
      return minDate && moment(date).format("YYYY") < moment(minDate).format("YYYY");
  }
};


/**
 * window 객체어 선언된 블로그 생성일 호출
 */
export const getBlogCreatedDate = () => {
  return (window.Config.blog.hasOwnProperty('created')) ? moment(window.Config.blog.created).format("YYYY-MM-DD") : null;
};


/**
 * 서비스별 검색 stroke 색상
 * @returns {string}
 */
export const getSearchEngineStrokeColorByService = () =>{
  return isDaumBlogDomain() ? "#1a9be4" : "#FF5544";
};
